import { Box, Spinner } from '@chakra-ui/react';

import { LoadingIndicatorProps } from './LoadingIndicator.props';

const LoadingIndicatorView = (props: LoadingIndicatorProps): JSX.Element => {
  return (
    <Box
      display="flex"
      height="100vh"
      width="100%"
      alignItems="center"
      justifyContent="center">
      <Spinner size="xl" />
    </Box>
  );
};

export default LoadingIndicatorView;
